import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import {
  endOfTheDayDate,
  startOfTheDayDate,
  utcDateTime,
} from '@epicuro-next/utilities';

export function mapFilterValuesToQueryValues(
  fieldId: string,
  value: string,
): string[] {
  if (fieldId === FiltersFieldIds.DeliveryMonth) {
    const end = utcDateTime(value).plus({ months: 1 }).toISODate();
    return [value, end];
  }

  if (fieldId === FiltersFieldIds.PlacedPeriod) {
    // Placed period value is ISO interval
    const [start, end] = value.split('/');
    return [startOfTheDayDate(start), endOfTheDayDate(end)];
  }

  return [value];
}
